import DoorTypesEnum from '../../../enums/assemblies/door-types.enum';
import HandlingEquipmentsEnum from '../../../enums/assemblies/handling-equipments.enum';
import DatePeriodsEnum from '../../../enums/date-periods.enum';

class SaveAssemblyDto {
  firstName!: string;
  lastName!: string;
  email!: string;
  phoneNumber!: string;
  deliveryDate!: string;
  deliveryTime!: string;
  deliveryDatePreference!: string;
  deliveryDatePeriodPreference!: DatePeriodsEnum;
  handlingEquipment!: HandlingEquipmentsEnum;
  doorType!: DoorTypesEnum;
  doorNumber!: number;
  needsNotes?: string;
  disassemblyDate!: string;
  wasteQuantity!: number;
  wasteWood!: boolean;
  wasteConcreteOrBricks!: boolean;
  wasteDrywall!: boolean;
  wasteOther!: string | null;
}

export default SaveAssemblyDto;
